import * as Comlink from "comlink";
import { createWorker } from "./create";
import { newRelicManager } from "gather-browser-newrelic-manager/dist/src/public/newRelicManager";
const worker = createWorker(Comlink, () => new Worker(new URL("./main.worker.js", import.meta.url)));
worker.setMetricsReporter(Comlink.proxy((...args) => newRelicManager.addPageActionReliably(...args)));
worker.beginCollecting();
export default worker;
//# sourceMappingURL=WebWorkerClient.js.map